import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Sparkles } from "lucide-react";

const MODELS = [
    { id: "gemini-3-flash", label: "Gemini 3 Flash (Fast)" },
    { id: "gpt-5.2", label: "GPT-5.2 (Accurate)" },
    { id: "claude-sonnet-4.5", label: "Claude Sonnet 4.5" },
];

export function ModelPicker({ value, onChange }) {
    return (
        <Select value={value} onValueChange={onChange}>
            <SelectTrigger
                data-testid="model-picker"
                className="w-[190px] h-9 bg-surface border-border rounded-sm font-mono text-xs"
            >
                <Sparkles className="w-3.5 h-3.5 text-volt mr-1.5" />
                <SelectValue placeholder="Select model" />
            </SelectTrigger>
            <SelectContent className="bg-surface2 border-border">
                {MODELS.map((m) => (
                    <SelectItem key={m.id} value={m.id} className="font-mono text-xs" data-testid={`model-${m.id}`}>
                        {m.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
